<qai-floating-select [options]="assignmentOptions" [placement]="'below-start'" [offset]="4" [shape]="'round'"
          [value]="selectedAssignmentType" (valueChange)="onAssignmentChange($event)"></qai-floating-select>
